var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, ModelSync } from 'vue-property-decorator';
import { BRow, BCol, BFormRadioGroup, BFormRadio, BFormGroup, BFormSelect } from 'bootstrap-vue';
import axios from 'axios';
import FrameStyleSlider from 'components/standard-size-picture-frames/FrameStyleSlider.vue';
import FrameWidthSlider from 'components/standard-size-picture-frames/FrameWidthSlider.vue';
import MouldingColourSelect from 'components/moulding/MouldingColourSelect.vue';
import MountWidthSlider from 'components/standard-size-picture-frames/MountWidthSlider.vue';
import MountboardColours from 'components/MountboardColours.vue';
let FrameFilters = class FrameFilters extends Vue {
    constructor() {
        super(...arguments);
        this.mountboards = {
            featured: [],
            standard: []
        };
        this.sortByOptions = [
            { value: 'favourites', text: 'Favourites' },
            { value: 'price', text: 'Price' },
            { value: 'width', text: 'Width' },
            { value: 'depth', text: 'Depth' },
            { value: 'rebate_depth', text: 'Rebate Depth' },
        ];
        this.orderOptions = [
            { value: 'asc', text: 'Ascending' },
            { value: 'desc', text: 'Descending' }
        ];
    }
    mounted() {
        axios
            .get('/api/materials/mountboard/forSale')
            .then(({ data }) => this.mountboards = data);
    }
};
__decorate([
    ModelSync('filters', 'change', Object)
], FrameFilters.prototype, "selectedFilters", void 0);
FrameFilters = __decorate([
    Component({
        components: {
            BRow, BCol, BFormRadioGroup, BFormRadio, BFormGroup, BFormSelect,
            FrameStyleSlider, FrameWidthSlider, MouldingColourSelect, MountWidthSlider, MountboardColours
        }
    })
], FrameFilters);
export default FrameFilters;
